import React from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { useAlert } from "../../context/AlertProvider";

const EmailAttachment = ({ attachment }) => {
  const { showAlert } = useAlert();

  const handleDownload = async () => {
    const fileUrl = attachment.fileUrl; // Change as needed
    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = attachment.attachmentName; // Set filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlert(
      "success",
      "Download Complete",
      `${attachment.attachmentName} downloaded successfully.`,
    );
  };

  return (
    <div className="tw-inline-flex tw-items-center tw-gap-2.5 tw-bg-slate-50 hover:tw-bg-indigo-50/50 tw-border tw-border-solid tw-border-slate-200/80 hover:tw-border-theme/30 tw-rounded-lg tw-px-3 tw-py-1.5 tw-transition-all tw-duration-200 tw-group tw-max-w-xs">
      <i className="las la-paperclip tw-text-slate-400 group-hover:tw-text-theme tw-text-sm" />
      <span
        title={attachment.attachmentName}
        className="tw-text-xs tw-font-medium tw-text-slate-600 group-hover:tw-text-slate-700 tw-truncate tw-max-w-[150px]"
      >
        {attachment.attachmentName}
      </span>
      <button
        onClick={handleDownload}
        className="tw-flex tw-items-center tw-justify-center tw-p-1 tw-rounded-md tw-text-slate-400 hover:tw-text-theme hover:tw-bg-white tw-border tw-border-transparent hover:tw-border-slate-100 tw-transition-all tw-cursor-pointer tw-outline-none"
        title="Download file"
      >
        <DownloadOutlined className="tw-text-xs" />
      </button>
    </div>
  );
};

export default EmailAttachment;
